export const PERIOD_LIST = [
    {
        name: "Last One Hour",
        code: "hour",
        value: 1
    },
    {
        name: "Last 50 Points",
        code: "50points"
    },
    {
        name: "Custom Date Range (Last 15 Days)",
        code: "custom",
        value: "last-15days"
    },
    {
        name: "Custom Date Range (Historical)",
        code: "custom"
    }
];
export const GA_PERIOD_LIST = [
    {
        name: "Last 1 Week",
        code: "week",
        value: 1
    },
    {
        name: "Last 1 Month",
        code: "50points"
    },
    {
        name: "Custom Date Range (Historical)",
        code: "custom"
    }
];
export const ONE_DAY = [
    {
        name: "Custom Date Range (Last 1 Day)",
        code: "custom",
        value: "last-15days"
    }
];

export const SCATTER_PERIOD_LIST = [
    { name: "Last one Day", code: "true" },
    { name: "Custom Date Range", code: "custom" }
];
export const PERIOD_BATCH_LIST = [
    {
        name: "Last 50 Points",
        code: "50points"
    },
    {
        name: "Custom Date Range",
        code: "custom"
    }
];
export const PERIOD_QTY_LIST = [
    {
        name: 'Yesterday',
        code: 'day',
        value: 'custom'
    },
    {
        name: 'Custom Date Range',
        code: 'custom',
        value: 'custom'
    }
];
export const OPEN_V = 'open__v';
export const QTY_PIE = {
    in_spec__v: 0,
    out_spec__v: 0,
    caution__v: 0,
    open__v: 0
};
export const QTY_PIE_LABEL = {
    in_spec__v: 'In Spec',
    out_spec__v: 'Out of Spec',
    caution__v: 'Caution',
    open__v: 'Open'
};
export const PERIOD_DRILL_DOWN = ['Week', 'Month', 'Quarter'];
export const REPORTTYPE_DRILL_DOWN = {};
REPORTTYPE_DRILL_DOWN[PERIOD_DRILL_DOWN[0]] = 'Weekly';
REPORTTYPE_DRILL_DOWN[PERIOD_DRILL_DOWN[1]] = 'Monthly';
REPORTTYPE_DRILL_DOWN[PERIOD_DRILL_DOWN[2]] = 'Quarterly';
// REPORTTYPE_DRILL_DOWN[PERIOD_DRILL_DOWN[3]] = 'Yearly';

export const SKU = {
    skuName: 'Latest Run SKU',
    code: 'allSKUs',
};
export const MANUAL: string = 'Manual';
export const CONTINUOS = 'manualContinous';
export const BATCH = 'manualBatch';
export const MANUALBATCH = 'manualBatch';
export const DELETE_MSG = 'Are you sure want to delete the selected data?';
export const ALL = 'ALL';
export const MAIN: string = 'main';
export const HOUR: string = 'hour';
export const POINTS50: string = '50points';
export const DAY: string = 'day';
export const CR: string = 'CR';
export const NCR: string = 'NCR';
export const CUSTOM: string = 'custom';
export const GRANULARITYCHANGED: string = 'granularityChanged';
export const LANGUAGECHANGED: string = 'languageChanged';
export const DFOSLINES: string = 'dfosLines';
export const DFOS: string = 'dfos';
export const LANGUAGEMASTER: string = 'languageMaster';
export const USLLSLREDZONECHANGE: string = 'usllslRedZoneChange';
export const MARK_AS_OUTLIER: string = 'Mark as outlier';
export const PAGINATION: string = 'Pagination';
export const TIMESERIES: string = 'timeseries';
export const HISTOGRAM: string = 'histogram';
export const GA: string = 'ga';
export const GASUMMARY: string = 'gasummary';
export const SAVED_CLUSTER_LIST: string = 'savedClusterList';
export const SUMMARY: string = 'summary';
export const ALL_SKUS: any = { skuId: ALL, skuName: 'All SKUs' };
export const SELECTED_CLUSTER: string = 'selectedCluster';
export const SELECTED_FACTORY: string = 'selectedFactory';
export const A: string = 'A';
export const AA: string = 'AA';
export const B: string = 'B';
export const C: string = 'C';
export const SCATTER: string = 'scatter';
export const SEL_CUSTM_DATE: any = {
    from: null, to: null,
    convertedFrom: null, convertedTo: null
};
export const CREATE: string = 'create';
export const OVERLAP: string = 'overlap';
export const T4H: string = '24h';
export const DAYS: Array<string> = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
export const MONTH_NAMES: Array<string> = [
    'Jan', 'Feb', 'Mar',
    'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep',
    'Oct', 'Nov', 'Dec',
];
export const COL_CLASS: Array<string> = [
    "col-sm-6 col-md-6 col-ld-6",
    "col-sm-4 col-md-4 col-ld-4",
    "col-sm-3 col-md-3 col-ld-3",
];
export const RED_ZONE_FILTER: string = 'redZoneFilter';
export const INCIDENT: string = 'incident';
export const NEXT: string = 'next';
export const BACK: string = 'back';
export const ENGLISH: string = 'English';
export const FACTORYOFFSET: string = 'factoryOffset';
export const ADD: string = 'add';
export const EDIT: string = 'edit';
export const SUCCESS: string = 'Success';
export const YES: string = 'Yes';
export const NO: string = 'No';
export const PP: string = 'pp';
export const PPK: string = 'ppk';
export const CP: string = 'cp';
export const LAST_15_DAYS: string = 'last-15days';
export const COMPARE_CUSTOM: string = 'comparison-custom';
